/* eslint-disable jsx-a11y/anchor-is-valid */
import * as Yup from "yup";
import React, { useState } from "react";
import Loader from "../../Components/Loader/Loader";
import Layout from "../../Components/Layout/Layout";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { axiosInstance } from "../../Axios/https";
import { toast } from "react-toastify";

const UpdatePassword = () => {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const params = useParams();

  const initialValues = {
    password: "",
    password_confirm: "",
  };
  const initialSchema = Yup.object().shape({
    password: Yup.string().required("Password is required"),
    password_confirm: Yup.string().required("Password confirm is required"),
  });

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: initialSchema,
      onSubmit: (values) => {
        setLoader(true);
        const formData = new FormData();
        formData.append("password", values.password);
        formData.append("password_confirmation", values.password_confirm);
        axiosInstance
          .post(`reset-password/${params?.id}`, formData)
          .then((res) => {
            console.log(res?.data, "res?.data");
            if (res?.data?.status === true) {
              toast.success(res?.data?.message);
              navigate("/login");
              setLoader(false);
            } else {
              toast.error(res?.data?.message);
              setLoader(false);
            }
          })
          .catch((err) => {
            console.log(err);
            toast.error(err?.response?.data?.message);
            setLoader(false);
          });
      },
    });

  return (
    <>
      <Layout>
        <div className="inner-page-banner">
          <div className="breadcrumb-vec-btm">
            <img
              className="img-fluid"
              src="/assets/images/bg/inner-banner-btm-vec.png"
              alt=""
            />
          </div>
          <div className="container">
            <div className="row justify-content-center align-items-center text-center">
              <div className="col-lg-6 align-items-center">
                <div className="banner-content">
                  <h1>Update Password</h1>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={"/"}>Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Update Password
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="banner-img d-lg-block d-none">
                  <div className="banner-img-bg">
                    <img
                      className="img-fluid"
                      src="/assets/images/bg/inner-banner-vec.png"
                      alt=""
                    />
                  </div>
                  <img
                    className="img-fluid"
                    src="/assets/images/bg/inner-banner-img.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="h1-story-area two mb-120 pt-120">
          <div className="container">
            <div className="row gy-5 align-items-center justify-content-center">
              <div className="col-lg-6 d-flex flex-column justify-content-center align-items-center">
                <div className="section-title1">
                  <h2>Update Password</h2>
                </div>
                <div className="story-content form-wrapper col-12">
                  <div className="login-section">
                    <div className="container">
                      <div className="row d-flex justify-content-center g-4">
                        <div className="col-xl-12 col-lg-12 col-md-12">
                          <div
                            className="form-wrapper wow fadeInUp shadow-none"
                            data-wow-duration="1.5s"
                            data-wow-delay=".2s"
                          >
                            <form className="w-100" onSubmit={handleSubmit}>
                              <div className="row">
                                <div className="col-12">
                                  <div className="form-inner">
                                    <label>Enter Your Password *</label>
                                    <input
                                      type="password"
                                      placeholder="Enter Your Password"
                                      name="password"
                                      onChange={handleChange}
                                      value={values.password}
                                      onBlur={handleBlur}
                                    />
                                    {errors.password && touched.password ? (
                                      <span
                                        className="ms-2"
                                        style={{ color: "red" , fontSize : '16px' }}
                                      >
                                        {errors.password}
                                      </span>
                                    ) : null}
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="form-inner">
                                    <label>
                                      Enter Your Password Confirmation *
                                    </label>
                                    <input
                                      type="password"
                                      placeholder="Enter Your Password Confirmation"
                                      name="password_confirm"
                                      onChange={handleChange}
                                      value={values.password_confirm}
                                      onBlur={handleBlur}
                                    />
                                    {errors.password_confirm &&
                                    touched.password_confirm ? (
                                      <span
                                        className="ms-2"
                                        style={{ color: "red" , fontSize : '16px' }}
                                      >
                                        {errors.password_confirm}
                                      </span>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                              <button className="account-btn">
                                {loader ? <Loader /> : "Update Password"}
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default UpdatePassword;
